export default __webpack_public_path__ + "static/media/1C.fe4a1915.png";